/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Hungarian
export default {
  'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Kijelölés megszüntetése',
  'paginated-picker.async-select.menu-list.error-message.error-message': 'Nem sikerült lekérni az adatokat',
  'paginated-picker.async-select.menu-list.error-message.retry-message': 'Kattints az újrapróbálkozáshoz',
  'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Betöltés…',
  'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Több',
  'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
  'paginated-picker.async-select.select.no-options-message.no-options-message': 'Nincs egyezés',
  'paginated-picker.async-select.select.option.error-message': 'Nem sikerült lekérni az adatokat',
  'paginated-picker.async-select.select.option.retry-message': 'Kattints az újrapróbálkozáshoz',
  'paginated-picker.async-select.select.search-placeholder': 'Keresés',
  'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Teljes lista megjelenítése'
};